import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "label", "iconWrapper"]
  static values = {
    variantId: String,
    createUrl: String,
    destroyUrl: { type: String, default: "" },
    subscribed: { type: Boolean, default: false }
  }

  async toggle() {
    this.buttonTarget.disabled = true

    try {
      if (this.subscribedValue) {
        await this.unsubscribe()
      } else {
        await this.subscribe()
      }
    } finally {
      this.buttonTarget.disabled = false
    }
  }

  async subscribe() {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const response = await fetch(this.createUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: `variant_id=${this.variantIdValue}`
    })

    if (response.ok) {
      const data = await response.json()
      this.destroyUrlValue = this.createUrlValue.replace(/\/?$/, `/${data.id}`)
      this.setSubscribedState(true)
    }
  }

  async unsubscribe() {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const response = await fetch(this.destroyUrlValue, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      }
    })

    if (response.ok) {
      this.destroyUrlValue = ""
      this.setSubscribedState(false)
    }
  }

  setSubscribedState(subscribed) {
    this.subscribedValue = subscribed
    if (subscribed) {
      this.iconWrapperTarget.innerHTML = '<i data-ph="bell-ringing" class="size-full"></i>'
      this.labelTarget.textContent = this.labelTarget.dataset.subscribedText
      this.buttonTarget.classList.remove("btn--accent")
      this.buttonTarget.classList.add("btn--accent-outline")
    } else {
      this.iconWrapperTarget.innerHTML = '<i data-ph="bell" class="size-full"></i>'
      this.labelTarget.textContent = this.labelTarget.dataset.notifyText
      this.buttonTarget.classList.remove("btn--accent-outline")
      this.buttonTarget.classList.add("btn--accent")
    }
  }
}
